import { defineStore } from 'pinia';

import { getCustomDefaultMessage } from '../resources/js/api/lobbying';

let customDefaultMessagePromise = null;

export const useLobbyStore = defineStore('lobby', {
  state: () => {
    return {
      customDefaultMessage: null,
      isLoadingCustomDefaultMessage: false,
    };
  },
  actions: {
    async fetchCustomDefaultMessage() {
      if (this.customDefaultMessage) {
        return this.customDefaultMessage;
      }

      if (customDefaultMessagePromise) {
        return customDefaultMessagePromise;
      }

      this.isLoadingCustomDefaultMessage = true;
      customDefaultMessagePromise = getCustomDefaultMessage()
        .then(response => {
          this.customDefaultMessage = response?.body || null;
          return this.customDefaultMessage;
        })
        .catch(error => {
          console.warn('Unable to fetch custom lobby default message:', error);
          return null;
        })
        .finally(() => {
          this.isLoadingCustomDefaultMessage = false;
          customDefaultMessagePromise = null;
        });

      return customDefaultMessagePromise;
    },
  },
});
